export const AudienceType = {
  INVITEE_ONLY: 'InviteeOnly',
  GUEST_ONLY: 'GuestOnly',
  INVITEE_AND_GUEST: 'InviteeAndGuest'
};
